import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getAllGathers = (eventId) => {
  return axios.get(`${getBackendUrl()}/event/${eventId}/gather`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getMyGather = (eventId) => {
  return axios.get(`${getBackendUrl()}/event/${eventId}/mygather`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const getGather = (eventId, id) => {
  return axios.get(`${getBackendUrl()}/event/${eventId}/gather/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addGather = (gather) => {
  return axios.put(`${getBackendUrl()}/event/${gather.eventId}/gather`, gather, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const joinGather = (gather) => {
  return axios.post(`${getBackendUrl()}/event/${gather.eventId}/gather/${gather.id}/join`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const leaveGather = (gather) => {
  return axios.post(`${getBackendUrl()}/event/${gather.eventId}/gather/${gather.id}/leave`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const setGatherStatus = (gather) => {
  return axios.post(`${getBackendUrl()}/event/${gather.eventId}/gather/${gather.id}/next`, {}, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeGather = (gather) => {
  return axios.delete(`${getBackendUrl()}/event/${gather.eventId}/gather/${gather.id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};